


export const RELEASE_DATE_FOR_TIPTAP_EDITOR = '2025-01-29 12:30:00.000000' // TODO: This needs to be updated based on the release date of the new tiptap editor.
export const switchDateToNewCalculation = "2025-06-19 18:30:00"; // UTC
export const SOMETHING_WENT_WRONG = "Something went wrong";

export const EVENT_TAB_MODAL = {
  Heading: "Warning",
  Description: "On switching the type of event to 'Free' all the tickets created will be discarded. Continue?",
  Free: "is_free",
  CommunityTicket: "Community Ticket",
  RegularTicket: "Regular Ticket",
  TicketDetails: "ticket_details",
  PrimaryButtonText: "Ok",

};

export const TOOLTIP_CONTENT = {
  CodeExpired: "Code has expired.",
  GroupDescription: "Group Discount Code is auto-applied. Participants are not required to enter.",
  CopyCode: "Copy code",
};

export const CHECKIN_MODES = {
  MANUAL: 2,
  SILENT: 1,
};
export const PRINT_MODES = {
  MANUAL_PRINTING: 2,
  SILENT_PRINTING: 1,
};
export const PRINT_TYPE = {
  SINGLE_SIDED_PRINTING: 1,
  DOUBLE_SIDED_PRINTING: 2,
};

export const TABLE_CELLS_NAMES = {
  MANUAL: "Manual",
  SILENT: "Silent",
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
}
export const SCREENS = {
  EDIT_CHECK_IN: "EditCheckIn",
  ADD_CHECK_IN: "AddCheckIn",
};

export const REUSABLE_SCREENS = {
  showListOfItems: "showListOfItems",
  addScreen: "addScreen",
  editScreen: "editScreen"
}


export const TEMPLATE_TYPES = {
  smsTemplates: "SMS Templates",
  whatsappTemplates: "WhatsApp Templates",
  emailTemplates: "Email Templates"
};

export const DAYS_ARR = [
  {
    value: "7",
    label: "Last 7 days"
  },
  {
    value: "30",
    label: "Last 30 days"
  },
  {
    value: "90",
    label: "Last 90 days"
  }, {
    value: "custom",
    label: "Custom"
  }
]

export const COMPONENTS = {
  SETTLEMENTS: "settlements",
}

export const threeDecimalCurrencies = ["KWD", "JOD", "OMR", "TND", "BHD"];

export const zeroDecimalCurrencies = [
  "BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA",
  "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"
];

export const currencyLocaleMap = {
  AED: "ar-AE", // United Arab Emirates
  AFN: "fa-AF", // Afghanistan
  ALL: "sq-AL", // Albania
  AMD: "hy-AM", // Armenia
  ANG: "nl-CW", // Curaçao
  AOA: "pt-AO", // Angola
  ARS: "es-AR", // Argentina
  AUD: "en-AU", // Australia
  AWG: "nl-AW", // Aruba
  AZN: "az-AZ", // Azerbaijan
  BAM: "bs-BA", // Bosnia and Herzegovina
  BBD: "en-BB", // Barbados
  BDT: "bn-BD", // Bangladesh
  BGN: "bg-BG", // Bulgaria
  BHD: "ar-BH", // Bahrain
  BIF: "fr-BI", // Burundi
  BMD: "en-BM", // Bermuda
  BND: "ms-BN", // Brunei
  BOB: "es-BO", // Bolivia
  BRL: "pt-BR", // Brazil
  BSD: "en-BS", // Bahamas
  BWP: "en-BW", // Botswana
  BYN: "be-BY", // Belarus
  BZD: "en-BZ", // Belize
  CAD: "en-CA", // Canada
  CDF: "fr-CD", // Congo (Kinshasa)
  CHF: "de-CH", // Switzerland
  CLP: "es-CL", // Chile
  CNY: "zh-CN", // China
  COP: "es-CO", // Colombia
  CRC: "es-CR", // Costa Rica
  CVE: "pt-CV", // Cape Verde
  CZK: "cs-CZ", // Czech Republic
  DJF: "fr-DJ", // Djibouti
  DKK: "da-DK", // Denmark
  DOP: "es-DO", // Dominican Republic
  DZD: "ar-DZ", // Algeria
  EGP: "ar-EG", // Egypt
  ETB: "am-ET", // Ethiopia
  EUR: "fr-FR", // Eurozone (France example)
  FJD: "en-FJ", // Fiji
  FKP: "en-FK", // Falkland Islands
  GBP: "en-GB", // United Kingdom
  GEL: "ka-GE", // Georgia
  GIP: "en-GI", // Gibraltar
  GMD: "en-GM", // Gambia
  GNF: "fr-GN", // Guinea
  GTQ: "es-GT", // Guatemala
  GYD: "en-GY", // Guyana
  HKD: "zh-HK", // Hong Kong
  HNL: "es-HN", // Honduras
  HRK: "hr-HR", // Croatia
  HTG: "ht-HT", // Haiti
  HUF: "hu-HU", // Hungary
  IDR: "id-ID", // Indonesia
  ILS: "he-IL", // Israel
  INR: "hi-IN", // India
  ISK: "is-IS", // Iceland
  JMD: "en-JM", // Jamaica
  JOD: "ar-JO", // Jordan
  JPY: "ja-JP", // Japan
  KES: "sw-KE", // Kenya
  KGS: "ky-KG", // Kyrgyzstan
  KHR: "km-KH", // Cambodia
  KMF: "fr-KM", // Comoros
  KRW: "ko-KR", // South Korea
  KWD: "ar-KW", // Kuwait
  KYD: "en-KY", // Cayman Islands
  KZT: "kk-KZ", // Kazakhstan
  LAK: "lo-LA", // Laos
  LBP: "ar-LB", // Lebanon
  LKR: "si-LK", // Sri Lanka
  LRD: "en-LR", // Liberia
  LSL: "en-LS", // Lesotho
  MAD: "ar-MA", // Morocco
  MDL: "ro-MD", // Moldova
  MGA: "fr-MG", // Madagascar
  MKD: "mk-MK", // North Macedonia
  MMK: "my-MM", // Myanmar
  MNT: "mn-MN", // Mongolia
  MOP: "zh-MO", // Macau
  MUR: "en-MU", // Mauritius
  MVR: "dv-MV", // Maldives
  MWK: "en-MW", // Malawi
  MXN: "es-MX", // Mexico
  MYR: "ms-MY", // Malaysia
  MZN: "pt-MZ", // Mozambique
  NAD: "en-NA", // Namibia
  NGN: "en-NG", // Nigeria
  NIO: "es-NI", // Nicaragua
  NOK: "nb-NO", // Norway
  NPR: "ne-NP", // Nepal
  NZD: "en-NZ", // New Zealand
  OMR: "ar-OM", // Oman
  PAB: "es-PA", // Panama
  PEN: "es-PE", // Peru
  PGK: "en-PG", // Papua New Guinea
  PHP: "tl-PH", // Philippines
  PKR: "ur-PK", // Pakistan
  PLN: "pl-PL", // Poland
  PYG: "gn-PY", // Paraguay
  QAR: "ar-QA", // Qatar
  RON: "ro-RO", // Romania
  RSD: "sr-RS", // Serbia
  RUB: "ru-RU", // Russia
  RWF: "rw-RW", // Rwanda
  SAR: "ar-SA", // Saudi Arabia
  SBD: "en-SB", // Solomon Islands
  SCR: "en-SC", // Seychelles
  SEK: "sv-SE", // Sweden
  SGD: "en-SG", // Singapore
  SHP: "en-SH", // St. Helena
  SLE: "en-SL", // Sierra Leone
  SOS: "so-SO", // Somalia
  SRD: "nl-SR", // Suriname
  STD: "pt-ST", // São Tomé and Príncipe
  SZL: "en-SZ", // Eswatini
  THB: "th-TH", // Thailand
  TJS: "tg-TJ", // Tajikistan
  TND: "ar-TN", // Tunisia
  TOP: "to-TO", // Tonga
  TRY: "tr-TR", // Turkey
  TTD: "en-TT", // Trinidad & Tobago
  TWD: "zh-TW", // Taiwan
  TZS: "sw-TZ", // Tanzania
  UAH: "uk-UA", // Ukraine
  UGX: "en-UG", // Uganda
  USD: "en-US", // United States
  UYU: "es-UY", // Uruguay
  UZS: "uz-UZ", // Uzbekistan
  VND: "vi-VN", // Vietnam
  VUV: "bi-VU", // Vanuatu
  WST: "sm-WS", // Samoa
  XAF: "fr-CM", // Central Africa
  XCD: "en-GD", // East Caribbean
  XOF: "fr-SN", // West Africa
  XPF: "fr-PF", // French Polynesia
  YER: "ar-YE", // Yemen
  ZAR: "en-ZA", // South Africa
  ZMW: "en-ZM", // Zambia
};

export const paymentMethodMap = {
  UPI: 1,
  CARDS: 2,
  NETBANKING: 3,
  WALLETS: 5,
};

export const ORDER_TYPES = {
  FUND: 1,
  CREDIT: 2,
}


export const CREDIT_TRANSACTION_TYPES = {
  CREDIT_ORDER_CAPTURED: 29,        // Transaction indicating a successful credit purchase
  CREDIT_ORDER_FAILED: 30,          // Transaction indicating a failed credit purchase
  CREDIT_TRANSFERRED_TO: 32,        // Credits transferred to a different event
  CREDIT_TRANSFERRED_FROM: 33,      // Credits transferred from a different event
  CREDIT_COMPLIMENTARY: 34,         // Default 10 credits provided for paid events as compliment
};

export const ManageEventsTabs = {
  ACTIVE: "active",
  PAST: "past",
}

export const AGENDA_FEEDBACK_TAB = {
  FEEDBACK_QUESTIONS: "Feedback Questions",
  ANALYTICS: "Analytics",
}

export const downloadAttendeesCheckboxesSection = {
  ATTENDEE_DETAILS: "attendeeDetails",
}

export const paymentGatewayForExternalSales = {
  COPPERX: "copperx"
};

export const whatsAppModes = {
  KONFHUB_WHATSAPP: 1,
  BYO_WABA: 2,
};

export const ADD_WABA_ERRORS = {
  WABA_NOT_FOUND: "WABA details not found for this event",
};

export const SWITCH_DIFFERENT_WABA_ERRORS = {
  DEPENDENT_ENTITIES_FOUND: "Dependent entities found for WhatsApp communication switch",
}

export const FACEBOOK_EMBED_SIGNUP_BUTTON_EVENTS = {
  EMBED_SIGNUP_FINISHED: "FINISH",
  EMBED_SIGNUP_CANCELLED: "CANCEL",
  EMBED_SIGNUP_ERROR: "ERROR",
}

export const keyWord = {
  ENTER: "Enter"
}
